import React from "react";

import styles from './members.module.scss';
import KoDP from "packages/dp";
import { KoText } from "packages/typography";
import KoDateFormatter from "packages/dateformat";

function KoStaicMembers(props) {
  const { data, size, row, feed, time, isCustom, Elements } = props;
  return (
    data?.firstName && <div className={`profileChar ${styles.membersWrapper} ${feed && styles.feed}`}>
      <div className={`${styles.circle}  ${data ?
        data?.firstName?.charAt(0).toLowerCase() : 'a'}`}>
        {data?.['logo'] ?
          <KoDP className={styles.btn} shape={'circle'} logo={data?.logo}
            width={data?.logo?.[0]?.name ? size ? size : 25 : 25}
            height={data?.logo?.[0]?.name ? size ? size : 25 : 25} />
          :
          <KoText className={`${styles.letter}`} text={data?.firstName?.charAt(0)} />
        }
      </div>
      <div className={styles.memberInfo}>
        <KoText ellipsis={true} text={`${data?.firstName} ${data?.lastName ? data?.lastName : ''}`} className={styles.memberName} />
        {(data?.email || row?.email) && <KoText text={`${data?.email || row?.email}`} className={styles.email} />}
        {(data?.date) && <KoDateFormatter  data={data?.date} className={styles.date} />}
        {time && <KoText text={`${time}`} className={styles.email} />}
        {/* {row?.designation && <KoText text={`${data?.designation || row?.designation}`} className={styles.designation} />} */}
        {isCustom&& <Elements/>}
      </div>
    </div>
  );
}
export default KoStaicMembers;
